import CustomSelect from "../common/Inputs/CustomSelect";
import { CustomMultiSelect } from "../common/Inputs/MultiSelectInput";
import { useAuth } from "../../context/AuthContext";
import { useMemo } from "react";

interface Props {
  /** @mantine/form örneği; tagIds, departmentIds, contractId alanlarını yönetir. */
  form: any;
}

/**
 * Personel formlarındaki rol/yetenek + departman + kontrat üçlüsü.
 *
 * Etiketin departman/kontrat "paketi" (bundle) 1 Eyl'de kaldırıldı: üç alan da
 * bağımsız, İK ne seçtiyse o kaydedilir. Alan kilitleme / "elle ayarla"
 * (`policyOverrides`) mekanizması da onunla birlikte gitti.
 */
const EmployeeTagFields = ({ form }: Props) => {
  const { tagSelectData, departmentSelectData, contractSelectData } = useAuth();

  const allTags = useMemo(
    () => [...tagSelectData.role, ...tagSelectData.skill],
    [tagSelectData]
  );

  return (
    <>
      <CustomMultiSelect
        label="Rol / Yetenek"
        searchable
        placeholder="Rol veya yetenek seçiniz."
        w="100%"
        data={allTags}
        {...form.getInputProps("tagIds")}
      />

      <CustomMultiSelect
        label="Departman"
        placeholder="Departman Seçiniz."
        w="100%"
        data={departmentSelectData}
        {...form.getInputProps("departmentIds")}
      />

      <CustomSelect
        label="Kontrat"
        placeholder="Kontrat seçiniz."
        w="100%"
        h={44}
        data={contractSelectData}
        withAsterisk
        {...form.getInputProps("contractId")}
      />
    </>
  );
};

export default EmployeeTagFields;
